import { createSelector } from 'reselect';

export const getEntityDataSelector = state => state.resourceHandler;

// Using formal selector to allow the format of the resourceHandler store to change down the road.

// just a map of type: Map({ Entity : Map({data... }), ... })
// export const getEntityDataSelector = createSelector(resourceHandlerSelector, entities => entities);
